export enum SearchParamEnum {
  Dialog = 'dialog'
}

export enum DialogStateEnum {
  Open = 'open',
  Confirm = 'confirm'
}

export type HandleClose = () => void;
